import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { prevalidateconfiguration } from '../validateconfiguration-popup/validateconfiguration-popup.component';
import { CommonService } from 'src/app/shared/services/common.service';

export interface FormData {

  formType: string,
  objectData: any;
}
@Component({
    selector: 'app-validation-configuration-form',
    templateUrl: './validation-configuration-form.component.html',
    styleUrls: ['./validation-configuration-form.component.scss'],
    standalone: false
})

export class ValidationConfigurationFormComponent implements OnInit {
  isDisabled: boolean;


  constructor(@Inject(MAT_DIALOG_DATA) public data: FormData,
    private localStorageSettings: LocalStorageSettingsService,
    public dialogRef: MatDialogRef<ValidationConfigurationFormComponent>,
    private service: EtlService, private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,private commonService: CommonService) { }

  FormValid: FormGroup;
  retrivalType: string
  status: string;
  buttonName: string;
  backgroundColorButton: string;
  dnsId: string;
  statusvalue: boolean;;
  configurationList: prevalidateconfiguration[] = [];
  retrievalTypeOptions:any = [];
  propertyTypeList:any = []


  prevalidateconfiguration: any = {
    'propertyname': "",
    'propertytype': "",
    'expectedvalue': "",
    'validationlogic': "",
    'migrationid': 0,
    'dnsid': 0,
    'retrievaltype': "",
    'validationtype': "",
    'id': 0,
    'status': true
  }

  ngOnInit(): void {

    this.formValidations();
    this.dnsId = this.localStorageSettings.getSettings('dnsName')
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    console.log("background color button " + this.backgroundColorButton)
    this.buttonName = this.data.formType;
    console.log(this.data)
    this.FormValid.get('status').setValue(true)
    if (this.data.objectData != undefined) {
      if (this.data.objectData.status != 'Yes') {
        this.isDisabled = true;
        this.FormValid.get('status').setValue(false)
      }
      else {
        this.isDisabled = false;
        this.FormValid.get('status').setValue(true)
      }
      this.prevalidateconfiguration = {
        'propertyname': this.data.objectData.propertyname,
        'propertytype': this.data.objectData.propertytype,
        'expectedvalue': this.data.objectData.expectedvalue,
        'validationlogic': this.data.objectData.validationlogic,
        'migrationid': this.data.objectData.migrationid,
        'dnsid': this.data.objectData.dnsid,
        'retrievaltype': this.data.objectData.retrievaltype,
        'id': this.data.objectData.id,
        'status': this.isDisabled
      }

    }
    console.log("prevalidation configuration" + this.prevalidateconfiguration[0])
    this.commonService.getlookupVauleByLookUpType("retrievalType").subscribe(result=>{
      console.log(result);
      this.retrievalTypeOptions = result;
    })
    this.commonService.getlookupVauleByLookUpType("propertyType").subscribe(result=>{
      console.log(result);
      this.propertyTypeList = result;
    })
  }
  updateData() {
    this.configurationList = []
    this.spinner.start()
    try {
      if (this.FormValid.valid) {
        this.prevalidateconfiguration.migrationid = 0
        this.prevalidateconfiguration.dnsid = this.dnsId
        if (this.FormValid.get('status').value) {
          this.prevalidateconfiguration.status = "Yes";
        }
        else {
          this.prevalidateconfiguration.status = "No";
        }
        if (this.buttonName == "save") {
          this.prevalidateconfiguration.id = 0;
          console.log("save : " + this.prevalidateconfiguration)
          this.configurationList.push(this.prevalidateconfiguration)
          this.service.savePrevalidateConfiguration(this.dnsId, this.prevalidateconfiguration.migrationid, this.configurationList).subscribe(res => {
            if (res != undefined) {

              if (res["error"]) {
                this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
                this.spinner.stop()
              }
              else {

                this.snackBar.open("Updated successfully", "Ok", { duration: 5000 })
                this.spinner.stop()
                this.dialogRef.close(true)
              }
            }
            else {
              this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
              this.spinner.stop()
            }
          })
        }
        else {
          console.log("edit : " + this.prevalidateconfiguration)
          this.configurationList.push(this.prevalidateconfiguration)
          this.service.savePrevalidateConfiguration(this.dnsId, this.prevalidateconfiguration.migrationid, this.configurationList).subscribe(res => {
            if (res != undefined) {
              if (res["error"]) {
                this.snackBar.open("Something went wrong " + res["statusMessage"], "Ok", { duration: 5000 })
                this.spinner.stop()
              }
              else {

                this.snackBar.open("Updated successfully", "Ok", { duration: 5000 })
                this.spinner.stop()
                this.dialogRef.close(true)
              }
            }
            else {
              this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
              this.spinner.stop()
            }
          })
        }
      }
      else{
        this.snackBar.open("please fill all required fields","Ok",{duration:5000})
        this.spinner.stop()
      }
    }
    catch (e) {
      this.spinner.stop();
      this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
    }


  }
  close() {
    this.dialogRef.close();

  }

  formValidations() {
    this.FormValid = new FormGroup({
      'propertyname': new FormControl('', [Validators.required]),
      'propertytype': new FormControl('', [Validators.required]),
      'expectedvalue': new FormControl('', [Validators.required]),
      'validationlogic': new FormControl('', [Validators.required]),
      'retrievaltype': new FormControl('', [Validators.required]),
      'status': new FormControl('')
    });
  }
  onCheckboxChange(event: any) {

    if (event.target.checked) {
      this.isDisabled = false
    } else {
      this.isDisabled = true
    }
  }

}
